export default "__VITE_ASSET__Ysqr6bZb__"